import {Http} from 'vue-resource'
import config from '../config'

class CustomerService {
  getByDomain (domain) {
    return Http.get(config.API_URL + 'api/customers/domain/' + domain)
  }
}

const instance = new CustomerService()

export default instance;
